<template>
  <div class="topbar">
    <KeywordFilter :lookup="'parkings/fetch'" :limit="parkingsLimit" :pathOptions="pathOptions" @search="onSearch" />
    <div class="total_time_filter-container">
      <div>{{ $t('top_bar.sort_by_time') }}</div>
      <el-select name="landlord" v-model="selectedFilter" @change="fetchParkings">
        <el-option class="drop_down_option" value="" :label="$t('top_bar.sort_by_time')" />
        <el-option class="drop_down_option" value="desc" :label="$t('top_bar.long_to_short')" />
        <el-option class="drop_down_option" value="asc" :label="$t('top_bar.short_to_long')" />
      </el-select>
    </div>
    <!-- <div class="filter-container">
      <div class="topbar__filter filter"> -->
    <!-- <el-checkbox v-model="checked">Search by plate</el-checkbox> -->
    <!-- <div class="filter__checkbox checkbox">
          <label class="checkbox__label">
            <input type="checkbox" id="" name="" class="checkbox__input" v-model="searchByPlate" @change="selectedSearchByPlate">
            <span class="checkbox__custom-checkbox"></span>
            <span class="checkbox__title">{{ $t('parking.search_by_plate') }}</span>
          </label>
        </div>
          <el-date-picker
            v-if="windowWidth >= 700"
            class="filter__datepicker"
            v-model="valueTimeRange"
            type="daterange"
            range-separator="—"
            start-placeholder="Start date"
            end-placeholder="End date"
            align="center"
            format="dd.MM.yyyy"
            @change="selectedTime"
            @blur="selectedTime">
          </el-date-picker>
        <div v-else>
            <el-date-picker
              class="filter__datepicker filter__datepicker--start"
              v-model="valueTimeFrom"
              type="date"
              placeholder="Start date"
              align="center"
              format="dd.MM.yyyy"
              @change="selectedTimeMobile">
            </el-date-picker>
            <el-date-picker
              ref="datePickerTo"
              class="filter__datepicker filter__datepicker--end"
              v-model="valueTimeTo"
              type="date"
              placeholder="End date"
              align="center"
              format="dd.MM.yyyy"
              :picker-options="optionsTimeEnd"
              @change="selectedTimeMobile">
            </el-date-picker>
        </div>
      </div>
    </div> -->
    <div class=" total-time-filter-text  topbar__cell">
      <counters>
        <template slot="active">{{ parkings.active }}</template>
        <template slot="total">{{ parkings.total }}</template>
      </counters>
      <div class="buttonset">
        <router-link class="btn btn--secondary" :to="{ name: 'export-parking' }">{{ $t('top_bar.generate_report')
          }}</router-link>&nbsp;
        <!-- <router-link class="btn btn--main" :to="{ name: 'add-parking' }">{{ $t('top_bar.add_new_parking') }}</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Autocomplete from 'common/Autocomplete';
import Counters from 'common/Counters';
import Messages from 'common/Messages';
import KeywordFilter from 'parkings/KeywordFilter';
import moment from 'moment';
import * as mTypes from 'store/mutation-types';

export default {
  components: {
    Autocomplete,
    Counters,
    Messages,
    KeywordFilter,
  },
  data() {
    return {
      valueTimeRange: [],
      valueTimeFrom: '',
      valueTimeTo: '',
      pathOptions: {
        dateFrom: '',
        dateTo: '',
        searchByPlate: 0,
      },
      searchByPlate: false,
      query: null,
      selectedFilter: null,
      windowWidth: window.innerWidth,
      optionsTimeEnd: {
        disabledDate: date => date < new Date(this.valueTimeFrom),
      },
    };
  },
  watch: {
    valueTimeFrom() {
      if (new Date(this.valueTimeFrom) > new Date(this.valueTimeTo)) {
        this.valueTimeTo = '';
      }
    },
  },
  computed: mapGetters({
    parkings: 'landlord/parkings/parkings',
    parkingsLimit: 'landlord/parkings/limit',
    sortDuration: 'landlord/parkings/sortDuration',
  }),
  mounted() {
    this.$router.push({
      query: {
        searchByPlate: this.pathOptions.searchByPlate,
      }
    });
  },
  methods: {
    fetchParkings() {
      this.setSortDuration();
      this.$store.dispatch('landlord/parkings/fetch', { keyword: this.$route.query.keyword, user: this.user, limit: this.parkingsLimit })
        .then(() => {
          if (this.parkings.total === 0) {
            this.$router.push({ name: 'add-parking' });
          }
        });
    },
    setSortDuration() {
      this.$store.commit(`landlord/parkings/${mTypes.SET_SORT_DURATION}`, this.selectedFilter);
    },
    selectedTimeMobile() {
      if (this.valueTimeFrom && this.valueTimeTo) {
        this.pathOptions.dateFrom = moment(this.valueTimeFrom).format('YYYY-MM-DD');
        this.pathOptions.dateTo = moment(this.valueTimeTo).format('YYYY-MM-DD');

        this.queryPush();
      } else if (this.valueTimeFrom) {
        this.$refs.datePickerTo.focus();
      } else {
        this.pathOptions.dateFrom = '';
        this.pathOptions.dateTo = '';

        this.queryPush();
      }
    },
    selectedTime() {
      if (this.valueTimeRange && this.valueTimeRange.length > 0) {
        this.pathOptions.dateFrom = moment(this.valueTimeRange[0]).format('YYYY-MM-DD');
        this.pathOptions.dateTo = moment(this.valueTimeRange[1]).format('YYYY-MM-DD');
      } else {
        this.pathOptions.dateFrom = '';
        this.pathOptions.dateTo = '';
      }

      this.queryPush();
    },
    selectedSearchByPlate() {
      if (this.searchByPlate === true) {
        this.pathOptions.searchByPlate = 1;
      } else if (this.searchByPlate === false) {
        this.pathOptions.searchByPlate = 0;
      }

      this.queryPush();
    },
    onSearch(data) {
      this.query = data.query;
    },
    queryPush() {
      if (this.query
        && this.pathOptions.dateFrom
        && this.pathOptions.dateTo) {
        this.$router.push({
          query: {
            keyword: this.query,
            searchByPlate: this.pathOptions.searchByPlate,
            dateFrom: this.pathOptions.dateFrom,
            dateTo: this.pathOptions.dateTo,
          }
        });
      } else if (this.query) {
        this.$router.push({
          query: {
            keyword: this.query,
            searchByPlate: this.pathOptions.searchByPlate,
          }
        });
      } else if (this.pathOptions.dateFrom && this.pathOptions.dateTo) {
        this.$router.push({
          query: {
            searchByPlate: this.pathOptions.searchByPlate,
            dateFrom: this.pathOptions.dateFrom,
            dateTo: this.pathOptions.dateTo,
          }
        });
      } else {
        this.$router.push({
          query: {
            searchByPlate: this.pathOptions.searchByPlate,
          }
        });
      }

      this.$store.dispatch('landlord/parkings/fetch', {
        keyword: this.$route.query.keyword,
        user: this.user,
        limit: this.parkingsLimi,
        searchByPlate: this.pathOptions.searchByPlate,
        dateFrom: this.pathOptions.dateFrom,
        dateTo: this.pathOptions.dateTo,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.total_time_filter-container {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px;
  width: 100%;
  color: #7B7979;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  width: 100%;
}

@media screen and (min-width: 760px) {
  .total_time_filter-container {
    max-width: 470px;
    color: #7B7979;
    display: flex;
    background-color: #fff;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-top: 12px;
  }
}

@media screen and (min-width: 1110px) {
  .total_time_filter-container {
    max-width: 360px;
    margin-left: 12px;
  }
}

.messages {
  margin-right: 40px;
}

// .dashboard {
//   &__topbar {
//     align-items: flex-start;
//     margin: 0 0 45px 0;

//     @media screen and (min-width: 1116px) {
//       margin: 0 30px 45px 0;
//     }
//   }
// }

.filter {
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  gap: 30px;

  @media screen and (min-width: 900px) {
    align-items: center;
    flex-direction: row;
  }

  @media screen and (min-width: 1600px) {
    padding-top: 0px;
    padding-left: 30px;
  }

  &-container {
    display: flex;
    flex-direction: column;
    width: 100%;

    @media screen and (min-width: 1600px) {
      flex-direction: row;
      align-items: center;
      width: fit-content;
    }
  }

  &__datepicker {
    width: 100%;

    @media screen and (min-width: 900px) {
      width: fit-content;
    }

    &--start {
      margin-bottom: 10px;
    }
  }
}

.checkbox {
  white-space: nowrap;
  height: 40px;
  padding-top: 10px;

  &__input {
    display: none;

    &+.checkbox__custom-checkbox {
      width: 32px;
      height: 34px;
      margin: 10px 15px 10px 0;
      padding: 7.5px 15px;
      border: solid 1px var(--grey-five);
      cursor: pointer;
    }

    &:checked+.checkbox__custom-checkbox {
      margin: 10px 15px 10px 0;
      width: 32px;
      height: 34px;
      border: solid 1px var(--grey-five);
      cursor: pointer;
      position: relative;
      transition: all 225ms ease-in-out;

      &:after {
        content: ' ';
        position: absolute;
        top: 4px;
        left: 10px;
        width: 8px;
        height: 16px;
        transform: rotate(45deg);
        border: solid var(--brand-blue);
        border-width: 0 2px 2px 0;
        animation: checkBoxIn 245ms ease-in-out;
      }
    }
  }

  &__label {
    color: var(--black);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parkings/Topbar.vue